import { render, staticRenderFns } from "./TutorConfirmMobileToken.vue?vue&type=template&id=6136f136&"
import script from "./TutorConfirmMobileToken.vue?vue&type=script&lang=js&"
export * from "./TutorConfirmMobileToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports